import React from "react";
import SectionHeader from "@/components/shared/SectionHeader";
import { Brain, Database, Shield, Leaf, GraduationCap, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

const KEYS = [
  { k: "ai", icon: Brain },
  { k: "data", icon: Database },
  { k: "gov", icon: Shield },
  { k: "sus", icon: Leaf },
  { k: "exec", icon: GraduationCap, link: "/eisg" },
];

const BDSolutions = () => {
  const { t } = useI18n();
  return (
    <div>
      <section className="py-28 lg:py-36 bg-[#FAFAFA] border-b border-[#0A192F]/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <SectionHeader
            number={t("sol.hero.number")}
            eyebrow={t("sol.hero.eyebrow")}
            title={t("sol.hero.title")}
            subtitle={t("sol.hero.subtitle")}
            body={t("sol.hero.body")}
          />
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 space-y-px bg-[#0A192F]/10">
          {KEYS.map(({ k, icon: Icon, link }, idx) => (
            <div key={k} className="bg-white grid grid-cols-1 md:grid-cols-12 gap-8 p-10 lg:p-14 group">
              <div className="md:col-span-1">
                <div className="section-num">— {String(idx + 1).padStart(2, "0")}</div>
              </div>
              <div className="md:col-span-4">
                <Icon size={32} className="text-[#0A192F] mb-4" />
                <h3 className="font-bd text-3xl text-[#0A192F] tracking-tight leading-tight">{t(`sol.${k}.title`)}</h3>
              </div>
              <div className="md:col-span-5 text-[#0A192F]/75 leading-relaxed">
                <p className="text-lg">{t(`sol.${k}.desc`)}</p>
                <ul className="mt-5 grid grid-cols-2 gap-2 text-sm">
                  {[0, 1, 2, 3].map((i) => (
                    <li key={i} className="flex items-start gap-2 text-[#0A192F]/80">
                      <span className="w-1 h-1 rounded-full bg-[#D4AF37] mt-2 flex-shrink-0" />
                      <span>{t(`sol.${k}.${i}`)}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="md:col-span-2 flex md:justify-end items-start">
                {link && (
                  <Link to={link} className="inline-flex items-center gap-2 text-sm font-semibold text-[#F58220] hover:text-[#0A192F] link-underline">
                    {t("sol.exec.link")} <ArrowRight size={14} />
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BDSolutions;
